import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-info',
  templateUrl: './shared-info.component.html',
  styleUrls: ['./shared-info.component.scss'],
})
export class SharedInfoComponent {
  @Input() label?: string;
  @Input() content?: string;
  @Input() content_class: string = 'sp-color__primary';
  @Input() layout_class: string = 'sp-margin__bottom-x2';
  @Input() is_update_enabled?: boolean;
  @Input() update_tooltip?: string;
  @Input() is_content_clickable: boolean = false;
  @Output() content_click: EventEmitter<void> = new EventEmitter<void>();
  @Output() update_click: EventEmitter<void> = new EventEmitter<void>();
}
